import ApiService from "../../ApiService";

const RoomMemberService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/roommember/loadscreenview", searchVO, successCallback, failureCallback);
    },
    sendEmail: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/vipnotification/sendemail", vo, successCallback, failureCallback);
    },
    deleteMemberUsers: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/roommember/deleteroommembers", vo, successCallback, failureCallback);
    },
    shiftMemberStudents: (origClassId, targClassId, selectedIds, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/roommember/shiftmemberstudents", { origClassId, targClassId, selectedIds }, successCallback, failureCallback);
    },
    activateMemberAccount: (classId, selectedIds, roomId, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/roommember/activatememberaccount", { classId, selectedIds, roomId }, successCallback, failureCallback);
    },
};

export default RoomMemberService;
